import { toast } from 'sonner';

import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';

import { isHarnessError } from '../errors';
import { useSetDefaultHarness } from '../hooks/useSetDefaultHarness';
import type { Harness } from '../types';

/**
 * Shows the "Default" badge on the default harness, or a "Set as default"
 * action on every other harness (spec FR-009a).
 */
export function SetDefaultHarnessControl({ harness }: { harness: Harness }) {
  const setDefault = useSetDefaultHarness();

  if (harness.is_default) {
    return <Badge>Default</Badge>;
  }

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      disabled={setDefault.isPending}
      onClick={() => {
        setDefault.mutate(harness.id, {
          onError: (error) => {
            toast.error(
              isHarnessError(error)
                ? error.message
                : 'Could not set this harness as default. Please try again.',
            );
          },
        });
      }}
    >
      Set as default
    </Button>
  );
}
